









































































































































import { defineComponent, reactive } from '@vue/composition-api'
import type { Header } from '@/components/composables/useDataTable/types'
import { useDataTable } from '@/components/composables/useDataTable'
import ClientService from '@/services/client'
import CreateButton from '@/components/buttons/CreateButton.vue'
import EditButton from '@/components/buttons/EditButton.vue'
import ShowButton from '@/components/buttons/ShowButton.vue'
import ClientSearchFilters from '@/views/Clients/partials/ClientSearchFilters.vue'
import ClientStatus from '@/views/Clients/partials/ClientStatus.vue'
import { UserRoles } from '@/enums/UserRoles'
import StatCard from '@/components/Stats/StatCard.vue'

export default defineComponent({
  setup() {
    const searchParams = reactive({ filters: { admin: undefined, statuses: undefined } })
    const { items, totalRecords, loading, pagination, search, query, pages, fetchData } = useDataTable(
      ClientService,
      searchParams,
    )
    return {
      items,
      totalRecords,
      loading,
      pagination,
      search,
      query,
      pages,
      fetchData,
      ClientService,
      searchParams,
    }
  },
  name: 'ClientList',
  components: { StatCard, ClientStatus, ClientSearchFilters, ShowButton, EditButton, CreateButton },
  data() {
    return {
      shareholderList: [],
      adminList: [],
      statusList: [],
      statistics: {
        totalActive: 0,
        totalInactive: 0,
        totalPending: 0,
        totalRecords: 0,
      },
      statsLoading: true,
      filtersExpanded: false,
    }
  },
  computed: {
    activeFilterCount(): number {
      const f = this.searchParams.filters as { admin?: unknown[]; statuses?: unknown[] }
      let n = 0
      if (Array.isArray(f.admin) && f.admin.length) n += f.admin.length
      if (Array.isArray(f.statuses) && f.statuses.length) n += f.statuses.length
      return n
    },
    headers(): Array<Header> {
      return [
        { value: 'companyName', text: this.$t('companyName'), sortable: true },
        { value: 'country', text: this.$t('country'), sortable: true },
        { value: 'administrator', text: this.$t('administrator'), sortable: true },
        { value: 'status', text: this.$t('status'), sortable: true },
        { value: 'actions', text: this.$t('actions'), sortable: false, align: 'end' },
      ]
    },
    loggedInRole(): UserRoles {
      return this.$store.getters?.role
    },
    operable(): boolean {
      return [UserRoles.admin, UserRoles.operationDirector].includes(this.loggedInRole)
    },
  },
  methods: {
    async fetchStatistics() {
      this.statsLoading = true
      const { data } = await ClientService.statistics()
      this.statistics = data.data
      this.statsLoading = false
    },
  },
  watch: {
    totalRecords: function () {
      this.fetchStatistics()
    },
  },
})
